/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setDrawerButton.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * @name setDrawerButton
 * @description ドロワーナビの開閉
 * @param {Object} html html要素
 * @param {Object} DrawerButton ドロワーボタン
 * @param {Object} Links ドロワーナビのリンク
 * @param {String} --nav-open ドロワーナビオープン時のクラス
 */
const setDrawerButton = () => {
  let html = document.querySelector('html');
  let DrawerButton = document.querySelectorAll('.drawerButton__toggle');
  let Links = document.querySelectorAll('a[data-anchor="true"]');

  // ドロワーナビオープンorクローズ
  const navOpen = () => {
    html.classList.add("--nav-open");
  }

  // ドロワーナビクローズ
  const navClose = () => {
    html.classList.remove("--nav-open");
  }

  // ドロワーボタンクリック時
  DrawerButton.forEach((btn) => {
    btn.addEventListener("click", () => {
      html.classList.contains("--nav-open") ? navClose() : navOpen();
    });
  })

  // アンカーリンククリック時
  Links.forEach((link) => {
    link.addEventListener("click", navClose);
  })
};

export { setDrawerButton };